
document.addEventListener('DOMContentLoaded', function() {
  const MOBILE_BREAKPOINT = 750;
  let isSliderMode = window.innerWidth > MOBILE_BREAKPOINT;

  const tabs = document.querySelectorAll('.collection-tab');
  const sliderWrappers = document.querySelectorAll('.product-slider-wrapper');
  
  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      const collectionNumber = this.getAttribute('data-collection');
      
      tabs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      
      sliderWrappers.forEach(wrapper => wrapper.classList.remove('active'));
      const targetWrapper = document.querySelector(`[data-slider="${collectionNumber}"]`);
      if (targetWrapper) {
        targetWrapper.classList.add('active');
        if (isSliderMode) {
          initializeSlider(collectionNumber);
        }
      }
    });
  });
  
  const prevArrow = document.getElementById('prevArrow');
  const nextArrow = document.getElementById('nextArrow');
  
  // Initialize based on screen size
  function initializeAllSliders() {
    if (isSliderMode) {
      sliderWrappers.forEach(wrapper => {
        const sliderNumber = wrapper.getAttribute('data-slider');
        initializeSlider(sliderNumber);
      });
      prevArrow.style.display = 'flex';
      nextArrow.style.display = 'flex';
    } else {
      // Mobile mode - enable normal scroll
      sliderWrappers.forEach(wrapper => {
        const slider = wrapper.querySelector('[data-slider-track]');
        if (slider) {
          removeClones(slider);
          slider.style.transform = 'none';
          slider.style.transition = 'none';
        }
        wrapper.style.overflowX = 'auto';
      });
      prevArrow.style.display = 'none';
      nextArrow.style.display = 'none';
    }
  }
  
  function removeClones(slider) {
    const originalCardCount = parseInt(slider.dataset.originalCardCount);
    if (!originalCardCount) return;
    
    const allCards = slider.querySelectorAll('.product-card-container');
    allCards.forEach((card, index) => {
      if (index >= originalCardCount) {
        card.remove();
      }
    });
    
    slider.dataset.currentPage = '0';
  }
  
  function getPageSize(slider) {
    const sliderWrapper = slider.closest('.product-slider-wrapper');
    const containerWidth = sliderWrapper.offsetWidth;
    return containerWidth * 0.88; // 88% of container width per page
  }
  
  function getTotalPages(slider) {
    const cards = slider.querySelectorAll('.product-card-container');
    const originalCardCount = parseInt(slider.dataset.originalCardCount);
    
    if (!originalCardCount) return 0;
    
    const cardWidth = cards[0].offsetWidth;
    const gap = 20;
    const totalContentWidth = (cardWidth + gap) * originalCardCount - gap;
    const pageSize = getPageSize(slider);
    
    // Calculate how many pages we need
    return Math.ceil(totalContentWidth / pageSize);
  }
  
  function initializeSlider(sliderNumber) {
    const slider = document.querySelector(`[data-slider-track="${sliderNumber}"]`);
    if (!slider) return;
    
    // Remove any existing clones first
    const existingClones = slider.querySelectorAll('.product-card-container');
    const originalCount = parseInt(slider.dataset.originalCardCount);
    if (originalCount && existingClones.length > originalCount) {
      removeClones(slider);
    }
    
    const cards = slider.querySelectorAll('.product-card-container');
    const cardCount = cards.length;
    
    if (cardCount === 0) return;
    
    // Clone all cards once for seamless carousel
    cards.forEach(card => {
      const clone = card.cloneNode(true);
      slider.appendChild(clone);
    });
    
    const wrapper = slider.closest('.product-slider-wrapper');
    wrapper.style.overflowX = 'hidden';
    
    slider.dataset.currentPage = '0';
    slider.dataset.originalCardCount = cardCount;
    updateSliderPosition(slider, 0, false);
  }
  
  function updateSliderPosition(slider, pageNumber, animate = true) {
    const pageSize = getPageSize(slider);
    const scrollDistance = pageSize * pageNumber;
    
    if (animate) {
      slider.style.transition = 'transform 0.5s ease';
    } else {
      slider.style.transition = 'none';
    }
    
    slider.style.transform = `translateX(-${scrollDistance}px)`;
    slider.dataset.currentPage = pageNumber;
  }
  
  function getActiveSlider() {
    const activeWrapper = document.querySelector('.product-slider-wrapper.active');
    if (!activeWrapper) return null;
    
    const sliderNumber = activeWrapper.getAttribute('data-slider');
    return document.querySelector(`[data-slider-track="${sliderNumber}"]`);
  }
  
  // Next arrow - move to next page
  nextArrow.addEventListener('click', function() {
    if (!isSliderMode) return;
    
    const slider = getActiveSlider();
    if (!slider) return;
    
    let currentPage = parseInt(slider.dataset.currentPage || '0');
    const totalPages = getTotalPages(slider);
    
    currentPage++;
    
    // Calculate if we've reached the end of original cards
    const cards = slider.querySelectorAll('.product-card-container');
    const originalCardCount = parseInt(slider.dataset.originalCardCount);
    const cardWidth = cards[0].offsetWidth;
    const gap = 20;
    const totalOriginalWidth = (cardWidth + gap) * originalCardCount - gap;
    const pageSize = getPageSize(slider);
    const currentScrollPosition = pageSize * currentPage;
    
    // If current scroll would go past original content, loop back
    if (currentScrollPosition >= totalOriginalWidth) {
      // Animate to the clone position
      updateSliderPosition(slider, currentPage, true);
      
      // After animation, jump back to start
      setTimeout(() => {
        updateSliderPosition(slider, 0, false);
      }, 500);
    } else {
      updateSliderPosition(slider, currentPage, true);
    }
  });
  
  // Previous arrow - move to previous page
  prevArrow.addEventListener('click', function() {
    if (!isSliderMode) return;
    
    const slider = getActiveSlider();
    if (!slider) return;
    
    let currentPage = parseInt(slider.dataset.currentPage || '0');
    
    currentPage--;
    
    // If we go before the start, loop to end
    if (currentPage < 0) {
      // Calculate the last complete page position
      const cards = slider.querySelectorAll('.product-card-container');
      const originalCardCount = parseInt(slider.dataset.originalCardCount);
      const cardWidth = cards[0].offsetWidth;
      const gap = 20;
      const totalOriginalWidth = (cardWidth + gap) * originalCardCount - gap;
      const pageSize = getPageSize(slider);
      const totalPages = Math.ceil(totalOriginalWidth / pageSize);
      
      // Jump to the end of original content
      updateSliderPosition(slider, totalPages - 1, false);
    } else {
      updateSliderPosition(slider, currentPage, true);
    }
  });
  
  // Handle window resize
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      const wasSliderMode = isSliderMode;
      isSliderMode = window.innerWidth > MOBILE_BREAKPOINT;
      
      if (wasSliderMode !== isSliderMode) {
        initializeAllSliders();
      } else if (isSliderMode) {
        sliderWrappers.forEach(wrapper => {
          const sliderNumber = wrapper.getAttribute('data-slider');
          const slider = document.querySelector(`[data-slider-track="${sliderNumber}"]`);
          if (slider) {
            const currentPage = parseInt(slider.dataset.currentPage || '0');
            updateSliderPosition(slider, currentPage, false);
          }
        });
      }
    }, 250);
  });
  
  // Initialize on load
  initializeAllSliders();
});











  (function () {
    let currentProduct = null;
    let selectedOptions = {};

    document.addEventListener('DOMContentLoaded', function () {
      const modal = document.getElementById('quickViewModal');
      const overlay = modal.querySelector('.quick-view-overlay');
      const closeBtn = modal.querySelector('.quick-view-close');

      // Close modal function
      function closeModal() {
        modal.classList.remove('active');
        document.body.style.overflow = '';
      }

      // Event listeners for closing
      closeBtn.addEventListener('click', closeModal);
      overlay.addEventListener('click', closeModal);

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.classList.contains('active')) {
          closeModal();
        }
      });

      // Attach click handlers to all quick view buttons
      document.addEventListener('click', function (e) {
        const btn = e.target.closest('.quick-view-btn');
        if (btn) {
          e.preventDefault();
          const handle = btn.dataset.productHandle;
          if (handle) {
            openQuickView(handle);
          }
        }
      });

      // Open quick view modal
      async function openQuickView(handle) {
        try {
          const response = await fetch(`/products/${handle}.js`);
          if (!response.ok) throw new Error('Product not found');

          currentProduct = await response.json();
          displayProduct(currentProduct);

          modal.classList.add('active');
          document.body.style.overflow = 'hidden';
        } catch (error) {
          console.error('Error loading product:', error);
          alert('Error loading product. Please try again.');
        }
      }

      function displayProduct(product) {
        // Set basic info
        document.getElementById('quickViewSku').textContent = `SKU: ${product.id}`;
        document.getElementById('quickViewTitle').textContent = product.title;
        document.getElementById('quickViewVendor').textContent = product.vendor || '';

        // Initialize with first variant
        const firstVariant = product.variants[0];
        selectedOptions = {};

        product.options.forEach((option, index) => {
          if (option.name !== 'Title') {
            selectedOptions[option.name] = firstVariant.options[index];
          }
        });

        updatePrice(firstVariant);
        updateImages(product);
        buildVariantSelectors(product);
        setupQuantityControls();
        setupFormSubmit(product);
      }

      function updatePrice(variant) {
        const price = (variant.price / 100).toFixed(2);
        const comparePrice = variant.compare_at_price ? (variant.compare_at_price / 100).toFixed(2) : null;

        document.getElementById('quickViewPrice').textContent = `$${price}`;
        document.getElementById('quickViewVariantId').value = variant.id;

        const comparePriceEl = document.getElementById('quickViewComparePrice');
        const badgeEl = document.getElementById('quickViewBadge');

        if (comparePrice && parseFloat(comparePrice) > parseFloat(price)) {
          comparePriceEl.textContent = `$${comparePrice}`;
          comparePriceEl.style.display = 'inline';
          badgeEl.style.display = 'inline-block';
        } else {
          comparePriceEl.style.display = 'none';
          badgeEl.style.display = 'none';
        }
      }

      function updateImages(product) {
        const mainImage = document.getElementById('quickViewMainImage');
        const thumbnailsContainer = document.getElementById('quickViewThumbnails');

        if (product.featured_image) {
          mainImage.src = product.featured_image;
          mainImage.alt = product.title;
        }

        thumbnailsContainer.innerHTML = '';

        if (product.images && product.images.length > 1) {
          product.images.forEach((imageUrl, index) => {
            const thumb = document.createElement('div');
            thumb.className = `quick-view-thumbnail ${index === 0 ? 'active' : ''}`;
            thumb.innerHTML = `<img src="${imageUrl}" alt="${product.title}">`;

            thumb.addEventListener('click', function () {
              mainImage.src = imageUrl;
              document.querySelectorAll('.quick-view-thumbnail').forEach((t) => t.classList.remove('active'));
              this.classList.add('active');
            });

            thumbnailsContainer.appendChild(thumb);
          });
        }
      }

      function buildVariantSelectors(product) {
        const container = document.getElementById('quickViewVariants');
        container.innerHTML = '';

        if (!product.options || product.options[0].name === 'Title') {
          return;
        }

        product.options.forEach((option) => {
          const selector = document.createElement('div');
          selector.className = 'variant-selector';

          const label = document.createElement('label');
          label.textContent = `${option.name}:`;
          selector.appendChild(label);

          const optionsContainer = document.createElement('div');
          optionsContainer.className = 'variant-options';

          option.values.forEach((value) => {
            const optionEl = document.createElement('div');
            const isColorOption = option.name.toLowerCase() === 'color';

            optionEl.className = `variant-option ${!isColorOption ? 'size-option' : ''}`;

            if (selectedOptions[option.name] === value) {
              optionEl.classList.add('selected');
            }

            if (isColorOption) {
              // Find variant with this color to get image
              const variantWithColor = product.variants.find((v) => {
                const colorIndex = product.options.findIndex((o) => o.name === option.name);
                return v.options[colorIndex] === value;
              });

              if (variantWithColor && variantWithColor.featured_image) {
                optionEl.innerHTML = `<img src="${variantWithColor.featured_image.src}" alt="${value}">`;
              } else {
                optionEl.style.background = value.toLowerCase();
              }
            } else {
              optionEl.textContent = value;
            }

            optionEl.addEventListener('click', function () {
              if (!this.classList.contains('disabled')) {
                optionsContainer.querySelectorAll('.variant-option').forEach((o) => o.classList.remove('selected'));
                this.classList.add('selected');
                selectedOptions[option.name] = value;
                updateSelectedVariant();
              }
            });

            optionsContainer.appendChild(optionEl);
          });

          selector.appendChild(optionsContainer);
          container.appendChild(selector);
        });
      }

      function updateSelectedVariant() {
        const variant = findVariantByOptions(currentProduct, selectedOptions);

        if (variant) {
          updatePrice(variant);

          // Update main image if variant has one
          if (variant.featured_image) {
            const mainImage = document.getElementById('quickViewMainImage');
            mainImage.src = variant.featured_image.src;
          }
        }
      }

      function findVariantByOptions(product, options) {
        return product.variants.find((variant) => {
          return product.options.every((option, index) => {
            if (option.name === 'Title') return true;
            return variant.options[index] === options[option.name];
          });
        });
      }

      function setupQuantityControls() {
        const input = modal.querySelector('.quantity-input');
        const minusBtn = modal.querySelector('.quantity-minus');
        const plusBtn = modal.querySelector('.quantity-plus');

        minusBtn.onclick = function () {
          const val = parseInt(input.value);
          if (val > 1) input.value = val - 1;
        };

        plusBtn.onclick = function () {
          const val = parseInt(input.value);
          input.value = val + 1;
        };
      }

      function setupFormSubmit(product) {
        const form = document.getElementById('quickViewForm');

        form.onsubmit = async function (e) {
          e.preventDefault();

          const variantId = document.getElementById('quickViewVariantId').value;
          const quantity = parseInt(modal.querySelector('.quantity-input').value);

          const formData = {
            items: [
              {
                id: variantId,
                quantity: quantity,
              },
            ],
          };

          try {
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(formData),
            });

            if (response.ok) {
              window.location.href = '/cart';
            } else {
              alert('Error adding to cart. Please try again.');
            }
          } catch (error) {
            console.error('Error:', error);
            alert('Error adding to cart. Please try again.');
          }
        };
      }
    });
  })();
